'use strict';

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

require('lazysizes/plugins/object-fit/ls.object-fit');

require('lazysizes/plugins/parent-fit/ls.parent-fit');

require('lazysizes/plugins/rias/ls.rias');

require('lazysizes/plugins/bgset/ls.bgset');

require('lazysizes');

require('lazysizes/plugins/respimg/ls.respimg');

require('../../styles/theme.scss');

var _themeA11y = require('@shopify/theme-a11y');

require('../../../@Neptune/scripts/_n');

require('../../../@Neptune/scripts/neptune');

require('../../../@Neptune/scripts/debug');

require('../../../@Neptune/scripts/manifest');

require('../../../@Neptune/scripts/engage');

require('../../../@Neptune/scripts/surface');

require('../../../@Neptune/scripts/stratosphere');

require('../../../@Neptune/scripts/slider');

require('../../../@Neptune/scripts/liquid');

require('../../../@Neptune/scripts/periscope');

require('../../../@Neptune/scripts/history');

require('../../../@Neptune/scripts/transport');

require('../../../@Neptune/scripts/product');

require('../../../@Neptune/scripts/cart');

require('../../../@Neptune/scripts/swiper');

require('../../../@Neptune/scripts/sort');

require('../../../@Neptune/scripts/unique');

require('../../../@Neptune/scripts/brig');

require('../../../@Neptune/scripts/complete');

var _modal = require('../components/modal');

var _modal2 = _interopRequireDefault(_modal);

var _giveback = require('../sections/giveback');

var _giveback2 = _interopRequireDefault(_giveback);

require('../components/collection-filters');

var _sizeScale = require('../components/size-scale');

var _sizeScale2 = _interopRequireDefault(_sizeScale);

var _stepper = require('../components/stepper');

var _stepper2 = _interopRequireDefault(_stepper);

var _cards = require('../components/cards');

var _cards2 = _interopRequireDefault(_cards);

var _header = require('../sections/header');

var _header2 = _interopRequireDefault(_header);

var _corporateDiscount = require('../sections/corporateDiscount');

var _corporateDiscount2 = _interopRequireDefault(_corporateDiscount);

var _forms = require('../core/forms');

var _forms2 = _interopRequireDefault(_forms);

var _login = require('../templates/customers/login');

var _login2 = _interopRequireDefault(_login);

var _contentListWithImageSlideshow = require('../sections/content-list-with-image-slideshow');

var _contentListWithImageSlideshow2 = _interopRequireDefault(_contentListWithImageSlideshow);

var _storyViewer = require('../components/story-viewer');

var _storyViewer2 = _interopRequireDefault(_storyViewer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import {cookiesEnabled} from '@shopify/theme-cart';

// Common a11y fixes
(0, _themeA11y.focusHash)();
// import '../../styles/theme.scss.liquid';  

(0, _themeA11y.bindInPageLinks)();

// Apply a specific class to the html element for browser support of cookies.
if (window.navigator.cookieEnabled) {
		document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
}
// import '../../../@Neptune/scripts/passport';


Neptune.debug.init();

window.impact = function () {
		var impacts = projects.filter(function (p) {
				var _ref;

				return (_ref = []).concat.apply(_ref, (0, _toConsumableArray3.default)(cart.items.map(function (i) {
						return i.properties._tags;
				}))).includes(p.tag);
		});
		sessionStorage.setItem('impact', JSON.stringify(impacts));
		return impacts;
};

document.addEventListener('cart:updated', function (e) {
		console.log('cart:updated');
		impact();
		Neptune.templates.load('cart', window.cart);
});

document.addEventListener('cart:itemAdded', function (e) {
		Neptune.engage.action(_n.qs('body'), {
				'attributes': [{
						'att': 'data-active-modal',
						'set': 'drawer--cart'
				}]
		});
		impact();
});

document.addEventListener('template:rendered', function (e) {
		var el = e.detail.info.el;
		Neptune.periscope.init(el);
		Neptune.transport.init();
		Neptune.product.init(el);
		Neptune.manifest.init(el);
		Neptune.engage.init(el);
		Neptune.surface.init(el);
		Neptune.templates.init(el);
		Neptune.product.init(el);
		Neptune.slider.init(el);
		Neptune.swiper.init(el);
		Neptune.stratosphere.init(el);
		Neptune.unique.init(el);
		Neptune.sort.init(el);

		_modal2.default.init();
});

document.addEventListener('periscope:viewed', function (e) {
		var el = e.detail.info.el;

		Neptune.periscope.init(el);
		Neptune.transport.init();
		Neptune.product.init(el);
		Neptune.manifest.init(el);
		Neptune.engage.init(el);
		Neptune.surface.init(el);
		Neptune.templates.init(el);
		Neptune.product.init(el);
		Neptune.stratosphere.init(el);
		setTimeout(Neptune.slider.init, 500);
		Neptune.brig.init(el);
		Neptune.complete.init(el);
		Neptune.unique.init(el);
		Neptune.sort.init(el);
});

document.addEventListener("DOMContentLoaded", function (e) {

		Neptune.periscope.init();
		Neptune.product.init();
		Neptune.manifest.init();
		Neptune.engage.init();
		Neptune.surface.init();
		Neptune.templates.init();
		Neptune.slider.init();
		Neptune.swiper.init();
		Neptune.transport.init();
		Neptune.stratosphere.init();
		Neptune.unique.init();
		Neptune.sort.init();
		Neptune.brig.init();
		Neptune.complete.init();

		_modal2.default.init();

		Filters.init();
		_giveback2.default.init();
		impact();

		_storyViewer2.default.init();
		sessionStorage.setItem('impact', JSON.stringify(projects.filter(function (p) {
				return [].concat((0, _toConsumableArray3.default)(cart.items.map(function (i) {
						return i.properties._tags;
				})))[0].includes(p.tag);
		})));

		// document.addEventListener('engage:after', function(e){
		// Neptune.swiper.reset()
		// })

		if (window.performance && window.performance.navigation.type === window.performance.navigation.TYPE_BACK_FORWARD) {
				Neptune.cart.getCart();
		}
});